import Dexie, { type EntityTable } from 'dexie';
import type { ReviewLog, ReviewState, UserSettings } from '../types';

export const DEFAULT_SETTINGS: UserSettings = {
  id: 'settings',
  accent: 'us',
  timerEnabled: true,
  focusMinutes: 45,
  breakMinutes: 10,
  diagnosticCursor: 0,
  diagnosticComplete: false,
  offlineAudioComplete: false,
  offlineAudioCached: 0,
};

class MnemofluxDatabase extends Dexie {
  progress!: EntityTable<ReviewState, 'wordId'>;
  logs!: EntityTable<ReviewLog, 'id'>;
  settings!: EntityTable<UserSettings, 'id'>;

  constructor() {
    super('mnemoflux');
    this.version(1).stores({
      progress: '&wordId, suspended, updatedAt, card.due',
      logs: '++id, sessionId, wordId, reviewedAt, source',
      settings: '&id',
    });
  }
}

export const db = new MnemofluxDatabase();

export async function getSettings(): Promise<UserSettings> {
  const current = await db.settings.get('settings');
  if (current) return current;
  await db.settings.put(DEFAULT_SETTINGS);
  return DEFAULT_SETTINGS;
}

export async function updateSettings(patch: Partial<UserSettings>): Promise<UserSettings> {
  const current = await getSettings();
  const next = { ...current, ...patch, id: 'settings' as const };
  await db.settings.put(next);
  return next;
}
